import { Carousel } from "@mantine/carousel";
import { Box, Image, Modal, Text } from "@mantine/core";
import { useState } from "react";

export type GalleryFile = {
  id: string;
  url: string;
  name: string;
  type: string;
};

export function GalleryCarouselModal({
  gallery,
  height = 200,
}: {
  gallery: GalleryFile[];
  height?: number;
}) {
  const [openedImageIndex, setOpenedImageIndex] = useState<number | null>(null);

  return (
    <>
      <Carousel
        slideSize={`${height}px`}
        slideGap="md"
        withControls
        withIndicators={gallery.length > 1}
      >
        {gallery.map((file, idx) => (
          <Carousel.Slide key={file.id}>
            <Box
              style={{
                width: height,
                height: height,
                borderRadius: 8,
                overflow: "hidden",
                border: "1px solid #e9ecef",
                cursor: file.type === "IMAGE" ? "pointer" : undefined,
              }}
              onClick={
                file.type === "IMAGE"
                  ? () => setOpenedImageIndex(idx)
                  : undefined
              }
            >
              {file.type === "IMAGE" ? (
                <Image
                  src={file.url}
                  alt={file.name}
                  width={height}
                  height={height}
                  fit="cover"
                />
              ) : (
                <Text size="sm" c="dimmed">
                  {file.name}
                </Text>
              )}
            </Box>
          </Carousel.Slide>
        ))}
      </Carousel>
      <Modal.Root
        opened={openedImageIndex !== null}
        onClose={() => setOpenedImageIndex(null)}
        fullScreen
      >
        <Modal.Content style={{ background: "rgba(0, 0, 0, 0.50)" }}>
          <Modal.CloseButton
            onClick={() => setOpenedImageIndex(null)}
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              background: "black",
              color: "white",
              zIndex: 2,
            }}
          />
          {openedImageIndex !== null && (
            <Carousel
              initialSlide={openedImageIndex}
              withIndicators={gallery.length > 1}
              withControls
              styles={{
                root: { width: "100vw", height: "100vh" },
                container: { height: "100vh" },
              }}
              slideGap="md"
            >
              {gallery.map((file) => (
                <Carousel.Slide key={file.id}>
                  {file.type === "IMAGE" ? (
                    <Image
                      src={file.url}
                      alt={file.name}
                      fit="contain"
                      style={{
                        maxWidth: "100vw",
                        maxHeight: "100vh",
                        margin: "auto",
                      }}
                    />
                  ) : (
                    <Text size="sm" c="dimmed">
                      {file.name}
                    </Text>
                  )}
                </Carousel.Slide>
              ))}
            </Carousel>
          )}
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
